import React from "react";
import PropTypes from "prop-types";
import { Checkbox } from "@lululemon/ecom-pattern-library";

const SelectiveComparisonCheckbox = ({
  productId,
  categoryId,
  unifiedId,
  displayName,
  pdpUrl,
  shouldDisplaySelectiveComparison,
  productsToCompare,
  updateProductsToCompare,
  focusComparisonDrawer,
  images,
}) => {
  const openDrawerRef = React.useRef(null);
  const areProductsSelected = productsToCompare?.length > 0;

  const isProductSelectedForComparison = productsToCompare?.some(
    (p) => p.productId === productId
  );

  return (
    <>
      {shouldDisplaySelectiveComparison && (
        <Checkbox
          className="product-tile__checkbox OneLinkTx"
          required={false}
          classes={{
            labelContent: "lll-text-body-2",
          }}
          checked={isProductSelectedForComparison}
          id={productId}
          name={productId}
          onChange={(e) =>
            updateProductsToCompare({
              productId,
              categoryId,
              unifiedId,
              name: displayName,
              imageUrl: images?.length ? images?.[0].src : "",
              productUrl: pdpUrl,
            })
          }
        >
          <span className="lll-hidden-visually">
            Select for product comparison, {displayName}
          </span>
          Compare
        </Checkbox>
      )}
      {areProductsSelected && (
        <button
          className="lll-hidden-visually OneLinkTx"
          ref={openDrawerRef}
          onClick={() => focusComparisonDrawer(openDrawerRef)}
        >
          Open Comparison Drawer
        </button>
      )}
    </>
  );
};

SelectiveComparisonCheckbox.propTypes = {
  productId: PropTypes.string.isRequired,
  categoryId: PropTypes.string.isRequired,
  unifiedId: PropTypes.string.isRequired,
  displayName: PropTypes.string.isRequired,
  pdpUrl: PropTypes.string.isRequired,
  shouldDisplaySelectiveComparison: PropTypes.bool,
  productsToCompare: PropTypes.arrayOf(
    PropTypes.shape({
      productId: PropTypes.string.isRequired,
    })
  ),
  updateProductsToCompare: PropTypes.func.isRequired,
  focusComparisonDrawer: PropTypes.func.isRequired,
  images: PropTypes.arrayOf(
    PropTypes.shape({
      src: PropTypes.string.isRequired,
    })
  ),
};

SelectiveComparisonCheckbox.defaultProps = {
  shouldDisplaySelectiveComparison: false,
  productsToCompare: [],
  images: [],
};

export default SelectiveComparisonCheckbox;
